"use client";
import TextTruncate from "../textTruncate/TextTruncate";
import { HeaderVariantsProps } from "./type";
import WithBanner from "./WithBanner";
import WithIcons from "./WithIcons";
import WithImageGrid from "./WithImageGrid";
import WithSubHeading from "./WithSubHeading";
import WithTabs from "./WithTabs";

const HeaderVariants = (props: HeaderVariantsProps) => {
  if (props?.variant === "withTabs") return <WithTabs {...props} />;
  if (props?.variant === "withIcons") return <WithIcons {...props} />;
  if (props?.variant === "withBanner") return <WithBanner {...props} />;
  if (props?.variant === "withImageGrid") return <WithImageGrid {...props} />;
  if (props?.variant === "withSubheading") return <WithSubHeading {...props} />;
  return (
    <TextTruncate
      text={props?.subheading}
      className="max-w-[84rem]"
      truncateProps={{ offset: props?.textTruncateOffset }}
      translations={props?.translations}
    />
  );
};

export default HeaderVariants;
